const makeConstant = constant => `settings/${constant}`

export const FETCH_SETTINGS = makeConstant('FETCH_SETTINGS')
export const FETCH_SETTINGS_PENDING = makeConstant('FETCH_SETTINGS_PENDING')
export const FETCH_SETTINGS_SUCCESS = makeConstant('FETCH_SETTINGS_SUCCESS')
export const FETCH_SETTINGS_FAILED = makeConstant('FETCH_SETTINGS_FAILED')

export const FETCH_BOT_CONFIG = makeConstant('FETCH_BOT_CONFIG')
export const FETCH_BOT_CONFIG_PENDING = makeConstant('FETCH_BOT_CONFIG_PENDING')
export const FETCH_BOT_CONFIG_SUCCESS = makeConstant('FETCH_BOT_CONFIG_SUCCESS')
export const FETCH_BOT_CONFIG_FAILED = makeConstant('FETCH_BOT_CONFIG_FAILED')

export const FETCH_SYNCED_KNOWLEDGEBASE_LIST = makeConstant('FETCH_SYNCED_KNOWLEDGEBASE_LIST')
export const FETCH_SYNCED_KNOWLEDGEBASE_LIST_PENDING = makeConstant('FETCH_SYNCED_KNOWLEDGEBASE_LIST_PENDING')
export const FETCH_SYNCED_KNOWLEDGEBASE_LIST_SUCCESS = makeConstant('FETCH_SYNCED_KNOWLEDGEBASE_LIST_SUCCESS')
export const FETCH_SYNCED_KNOWLEDGEBASE_LIST_FAILED = makeConstant('FETCH_SYNCED_KNOWLEDGEBASE_FAILED')

export const SET_BOT_CONFIG = makeConstant('SET_BOT_CONFIG')
export const SET_BOT_CONFIG_PENDING = makeConstant('SET_BOT_CONFIG_PENDING')
export const SET_BOT_CONFIG_SUCCESS = makeConstant('SET_BOT_CONFIG_SUCCESS')
export const SET_BOT_CONFIG_FAILED = makeConstant('SET_BOT_CONFIG_FAILED')

export const UPDATE_SETTINGS = makeConstant('UPDATE_SETTINGS')
export const UPDATE_SETTINGS_PENDING = makeConstant('UPDATE_SETTINGS_PENDING')
export const UPDATE_SETTINGS_SUCCESS = makeConstant('UPDATE_SETTINGS_SUCCESS')
export const UPDATE_SETTINGS_FAILED = makeConstant('UPDATE_SETTINGS_FAILED')

export const SET_DRIFT_HELP_DOMAIN = makeConstant('SET_DRIFT_HELP_DOMAIN')
export const SET_CNAME_DOMAIN = makeConstant('SET_CNAME_DOMAIN')
export const SET_GOOGLE_ANALYTICS_CODE = makeConstant('SET_GOOGLE_ANALYTICS_CODE')
export const SET_TITLE = makeConstant('SET_TITLE')
export const SET_DESCRIPTION = makeConstant('SET_DESCRIPTION')
export const SET_TAGLINE = makeConstant('SET_TAGLINE')
export const SET_FAVICON = makeConstant('SET_FAVICON')
export const SET_LOGO = makeConstant('SET_LOGO')
export const SET_COLOR = makeConstant('SET_COLOR')

export const APPEND_TO_DOMAIN = makeConstant('APPEND_TO_DOMAIN')
export const UPDATE_KB_NO_INDEX = makeConstant('UPDATE_KB_NO_INDEX')

export const SET_SELECTED_CUSTOM_LINK = makeConstant('SET_SELECTED_CUSTOM_LINK')
export const CHANGE_CUSTOM_LINK_TEXT = makeConstant('CHANGE_CUSTOM_LINK_TEXT')
export const CHANGE_CUSTOM_LINK_URL = makeConstant('CHANGE_CUSTOM_LINK_URL')
export const CLEAR_CUSTOM_LINK = makeConstant('CLEAR_CUSTOM_LINK')

export const FETCH_CUSTOM_LINKS = makeConstant('FETCH_CUSTOM_LINKS')
export const FETCH_CUSTOM_LINKS_PENDING = makeConstant('FETCH_CUSTOM_LINKS_PENDING')
export const FETCH_CUSTOM_LINKS_SUCCESS = makeConstant('FETCH_CUSTOM_LINKS_SUCCESS')
export const FETCH_CUSTOM_LINKS_FAILED = makeConstant('FETCH_CUSTOM_LINKS_FAILED')

export const EDIT_CUSTOM_LINK = makeConstant('EDIT_CUSTOM_LINK')
export const EDIT_CUSTOM_LINK_PENDING = makeConstant('EDIT_CUSTOM_LINK_PENDING')
export const EDIT_CUSTOM_LINK_SUCCESS = makeConstant('EDIT_CUSTOM_LINK_SUCCESS')
export const EDIT_CUSTOM_LINK_FAILED = makeConstant('EDIT_CUSTOM_LINK_FAILED')

export const SAVE_CUSTOM_LINK = makeConstant('SAVE_CUSTOM_LINK')
export const SAVE_CUSTOM_LINK_PENDING = makeConstant('SAVE_CUSTOM_LINK_PENDING')
export const SAVE_CUSTOM_LINK_SUCCESS = makeConstant('SAVE_CUSTOM_LINK_SUCCESS')
export const SAVE_CUSTOM_LINK_FAILED = makeConstant('SAVE_CUSTOM_LINK_FAILED')

export const DELETE_CUSTOM_LINK = makeConstant('DELETE_CUSTOM_LINK')
export const DELETE_CUSTOM_LINK_PENDING = makeConstant('DELETE_CUSTOM_LINK_PENDING')
export const DELETE_CUSTOM_LINK_SUCCESS = makeConstant('DELETE_CUSTOM_LINK_SUCCESS')
export const DELETE_CUSTOM_LINK_FAILED = makeConstant('DELETE_CUSTOM_LINK_FAILED')